import { render, staticRenderFns } from "./ResizableLayout.vue?vue&type=template&id=85b1cb3e&"
import script from "./ResizableLayout.vue?vue&type=script&lang=js&"
export * from "./ResizableLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResizableLayout.vue?vue&type=style&index=0&id=85b1cb3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports